export const isEligibleForOnsiteTherapy = ({
  isOnsiteEligibleResponseEnabled,
  isOnsiteEligible,
  eligibleOnsiteAddressCount,
}: {
  isOnsiteEligibleResponseEnabled: boolean
  isOnsiteEligible?: boolean
  eligibleOnsiteAddressCount?: number
}): boolean => {
  if (!isOnsiteEligibleResponseEnabled) return true
  return isOnsiteEligible !== false && (eligibleOnsiteAddressCount ?? 0) > 0
}
